/* tslint:disable */

declare var Object: any;
export interface StorageLeaveInterface {
  "id"?: number;
}

export class StorageLeave implements StorageLeaveInterface {
  "id": number;
  constructor(data?: StorageLeaveInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `StorageLeave`.
   */
  public static getModelName() {
    return "StorageLeave";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of StorageLeave for dynamic purposes.
  **/
  public static factory(data: StorageLeaveInterface): StorageLeave{
    return new StorageLeave(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'StorageLeave',
      plural: 'StorageLeaves',
      path: 'StorageLeaves',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/StorageLeave.ts